import styled from '@emotion/styled';
import { Col, Row } from 'antd';
import React from 'react';
import { connect } from 'react-redux';

import { AppState } from 'src/config/appState';
import { StepBoxWrapper } from 'src/modules/programs/stepComponents/styles';
import { color, font, mediaQueries } from 'src/shared/styles/variables';

import { PlannedActivity } from '../../weekThree/models/weekThree';
import { getPlannedActivities } from '../../weekThree/selectors/weekThreeSelectors';
import { ActivityStatus } from './ActivityStatus';

const AreaActionsStatusWrapper = styled(StepBoxWrapper)({
    padding: '2rem',
});

const AreaHeader = styled(Row)({
    alignItems: 'center',
    borderBottom: `2px solid ${color.mariner}`,
    paddingBottom: '1rem',
    marginBottom: '1rem',
});

const AreaTitle = styled('h4')(
    {
        color: color.chathamsBlue,
        textTransform: 'capitalize',
    },
    font.heavy(font.size.large),
);

const StatusLabels = styled(Col)({
    display: 'flex',
    alignItems: 'center',
    [mediaQueries.sm]: {
        display: 'none',
    },
});

const StatusLabel = styled('span')(
    {
        display: 'block',
        width: '50%',
        textAlign: 'center',
        color: color.baliHai,
    },
    font.medium(font.size.base),
);

interface Props extends StateProps {
    activity: PlannedActivity;
}

interface StateProps {
    plannedActivities: PlannedActivity[];
}

export class AreaActivitiesStatusContainer extends React.Component<Props> {
    public render(): JSX.Element {
        const { activity } = this.props;

        return (
            <AreaActionsStatusWrapper>
                <AreaHeader type="flex">
                    <Col xs={24} sm={18}>
                        <AreaTitle>{activity.domainTitle}</AreaTitle>
                    </Col>
                    <StatusLabels xs={0} sm={6}>
                        <StatusLabel>Done</StatusLabel>
                        <StatusLabel>Not Done</StatusLabel>
                    </StatusLabels>
                </AreaHeader>
                <ActivityStatus key={activity.title} activity={activity} />
            </AreaActionsStatusWrapper>
        );
    }
}

const mapStateToProps = (state: AppState): StateProps => ({
    plannedActivities: getPlannedActivities(state),
});

export const AreaActivitiesStatus = connect(mapStateToProps)(AreaActivitiesStatusContainer);
